/* eslint-disable */

(() => {
  const ctaModules = document.querySelectorAll('.lungs-section');
  if (!ctaModules.length) return;

  const orbObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        orbObserver.unobserve(entry.target);
        initOrbSection(entry.target);
      });
    },
    { rootMargin: '200px' },
  );

  ctaModules.forEach((el) => orbObserver.observe(el));

  function initOrbSection(parent) {
    const app = parent.querySelector('.lungs-section__app');
    if (!app) return;

    // ===================== CONFIG =====================
    const isMobile = window.matchMedia('(pointer:coarse)').matches;
    const DPR = Math.min(window.devicePixelRatio || 1, isMobile ? 1.25 : 1.5);

    const COUNT_A = 8000;
    const COUNT_B = 8000;
    const POINT_SIZE_A = 0.005;
    const POINT_SIZE_B = 0.005;
    const COLOR_A = '#1E0256';
    const COLOR_B = '#1E0256';
    const ORB_RADIUS_A = 1.0;
    const ORB_RADIUS_B = 0.97;

    const INTRO_DURATION = 1;
    const SPAWN_POINT_WORLD = new THREE.Vector3(0, 4, 0);
    const SPAWN_SCATTER = 6;
    const FLOW_BEND = 0.1;
    const FLOW_TWIST = 0.05;
    const FLOW_TURB = 0.1;
    const FLOW_TURB_SCALE = 0.0;
    const INTRO_FADE_IN = 1.0;
    const FLOW_STOPS_AT = 0.01;
    const SETTLE_PULL = 0.15;
    const SETTLE_EPS = 1e-5;
    // ==================================================

    // --- Scene ---
    const scene = new THREE.Scene();

    // --- Camera ---
    const camera = new THREE.PerspectiveCamera(50, 1, 0.1, 1000);
    camera.position.z = 3;

    // --- Renderer ---
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(DPR);
    app.appendChild(renderer.domElement);

    // --- Resize ---
    const resizeRenderer = () => {
      const rect = app.getBoundingClientRect();
      const w = Math.max(1, rect.width);
      const h = Math.max(1, rect.height);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      renderer.setSize(w, h, false);
    };

    window.addEventListener('resize', debounce(resizeRenderer, 200));
    resizeRenderer();

    // --- OrbitControls (desktop only) ---
    let controls = null;
    if (!isMobile) {
      controls = new THREE.OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true;
      controls.dampingFactor = 0.08;
      controls.enablePan = false;
      controls.enableZoom = false;
      controls.autoRotate = false;
      controls.autoRotateSpeed = 3;
    } else {
      renderer.domElement.style.touchAction = 'pan-y';
    }

    // ===================== VISIBILITY =====================
    let isVisible = false;
    const visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        isVisible = entry.isIntersecting;
      },
      { rootMargin: '100px' },
    );
    visibilityObserver.observe(parent);

    // ===================== UTILS =====================
    const clamp01 = (x) => (x < 0 ? 0 : x > 1 ? 1 : x);

    const smootherstep = (x) => {
      x = clamp01(x);
      return x * x * x * (x * (x * 6 - 15) + 10);
    };

    const easeOutQuint = (x) => {
      x = clamp01(x);
      return 1 - Math.pow(1 - x, 5);
    };

    const smoothBell = (x) => {
      x = clamp01(x);
      return x * (1 - x) * 4;
    };

    const randomInSphere = (radius) => {
      let x, y, z;
      do {
        x = Math.random() * 2 - 1;
        y = Math.random() * 2 - 1;
        z = Math.random() * 2 - 1;
      } while (x * x + y * y + z * z > 1);
      return new THREE.Vector3(x, y, z).multiplyScalar(radius);
    };

    const hash01 = (n) => {
      const x = Math.sin(n * 12.9898) * 43758.5453;
      return x - Math.floor(x);
    };

    const hashVec3 = (i) => {
      const v = new THREE.Vector3(hash01(i * 3.1) * 2 - 1, hash01(i * 5.7) * 2 - 1, hash01(i * 9.2) * 2 - 1);
      if (v.lengthSq() < 1e-6) v.set(1, 0, 0);
      return v.normalize();
    };

    const turb = (x, y, z, t) =>
      (Math.sin(x * 1.3 + t * 1.2) + Math.sin(y * 1.7 - t * 0.9) + Math.sin(z * 1.5 + t * 1.1)) / 3;

    const fibonacciSpherePoint = (i, n) => {
      const offset = 2 / n;
      const y = i * offset - 1 + offset / 2;
      const r = Math.sqrt(Math.max(0, 1 - y * y));
      const phi = i * Math.PI * (3 - Math.sqrt(5));
      return new THREE.Vector3(Math.cos(phi) * r, y, Math.sin(phi) * r);
    };
    // ====================================================

    function createOrb({ count, pointSize, colorHex, radius }) {
      const target = new Float32Array(count * 3);
      const positions = new Float32Array(count * 3);
      const spawn = new Float32Array(count * 3);
      const rand = new Float32Array(count * 2);
      const side = new Float32Array(count * 3);

      for (let i = 0; i < count; i++) {
        const i3 = i * 3;

        const p = fibonacciSpherePoint(i, count).multiplyScalar(radius);
        target[i3] = p.x;
        target[i3 + 1] = p.y;
        target[i3 + 2] = p.z;

        const jitter = randomInSphere(SPAWN_SCATTER);
        spawn[i3] = SPAWN_POINT_WORLD.x + jitter.x;
        spawn[i3 + 1] = SPAWN_POINT_WORLD.y + jitter.y;
        spawn[i3 + 2] = SPAWN_POINT_WORLD.z + jitter.z;

        positions[i3] = spawn[i3];
        positions[i3 + 1] = spawn[i3 + 1];
        positions[i3 + 2] = spawn[i3 + 2];

        rand[i * 2] = hash01(i * 11.13) * Math.PI * 2;
        rand[i * 2 + 1] = 0.85 + hash01(i * 7.77) * 0.3;

        const hv = hashVec3(i);
        side[i3] = hv.x;
        side[i3 + 1] = hv.y;
        side[i3 + 2] = hv.z;
      }

      const geometry = new THREE.BufferGeometry();
      geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

      const material = new THREE.PointsMaterial({
        size: pointSize,
        sizeAttenuation: true,
        transparent: true,
        opacity: 0,
        depthWrite: false,
        color: new THREE.Color(colorHex),
      });

      const points = new THREE.Points(geometry, material);
      points.rotation.y = Math.PI * -0.15;
      scene.add(points);

      return { points, posAttr: geometry.attributes.position, spawn, target, rand, side, introDone: false };
    }

    const modelA = createOrb({ count: COUNT_A, pointSize: POINT_SIZE_A, colorHex: COLOR_A, radius: ORB_RADIUS_A });
    const modelB = createOrb({ count: COUNT_B, pointSize: POINT_SIZE_B, colorHex: COLOR_B, radius: ORB_RADIUS_B });

    if (controls) {
      controls.target.set(0, 0, 0);
      controls.autoRotate = true;
      controls.update();
    }

    // ===================== INTRO ANIMATION =====================
    function updateWaterIntro(model, t) {
      if (!model || model.introDone) return;

      const baseP = clamp01(t / INTRO_DURATION);
      model.points.material.opacity = smootherstep(clamp01(baseP / INTRO_FADE_IN));

      const pos = model.posAttr.array;
      const { spawn, target, rand, side } = model;

      for (let i = 0; i < model.posAttr.count; i++) {
        const i3 = i * 3;
        const speed = rand[i * 2 + 1];
        const phase = rand[i * 2];
        const p = clamp01(baseP * speed);
        const ePos = easeOutQuint(p);
        const eFlow = smootherstep(clamp01(p / FLOW_STOPS_AT));
        const bell = smoothBell(eFlow);

        const sx = spawn[i3],
          sy = spawn[i3 + 1],
          sz = spawn[i3 + 2];
        const tx = target[i3],
          ty = target[i3 + 1],
          tz = target[i3 + 2];

        let x = sx + (tx - sx) * ePos;
        let y = sy + (ty - sy) * ePos;
        let z = sz + (tz - sz) * ePos;

        const dx = tx - sx,
          dy = ty - sy,
          dz = tz - sz;
        const len = Math.sqrt(dx * dx + dy * dy + dz * dz) + 1e-6;
        const ux = dx / len,
          uy = dy / len,
          uz = dz / len;

        const sxv = side[i3],
          syv = side[i3 + 1],
          szv = side[i3 + 2];
        let cx = uy * szv - uz * syv;
        let cy = uz * sxv - ux * szv;
        let cz = ux * syv - uy * sxv;
        const clen = Math.sqrt(cx * cx + cy * cy + cz * cz) + 1e-6;
        cx /= clen;
        cy /= clen;
        cz /= clen;

        const bx = uy * cz - uz * cy;
        const by = uz * cx - ux * cz;
        const bz = ux * cy - uy * cx;

        const ang = phase + eFlow * Math.PI * 2.0;
        const cA = Math.cos(ang),
          sA = Math.sin(ang);
        const txv = cx * cA + bx * sA;
        const tyv = cy * cA + by * sA;
        const tzv = cz * cA + bz * sA;

        const tt = turb(x * FLOW_TURB_SCALE, y * FLOW_TURB_SCALE, z * FLOW_TURB_SCALE, t) * FLOW_TURB * bell;
        const bend = FLOW_BEND * bell;
        const twist = FLOW_TWIST * bell;

        pos[i3] = x + txv * twist + cx * bend + txv * tt;
        pos[i3 + 1] = y + tyv * twist + cy * bend + tyv * tt;
        pos[i3 + 2] = z + tzv * twist + cz * bend + tzv * tt;
      }

      model.posAttr.needsUpdate = true;

      if (baseP >= 1) {
        for (let i = 0; i < pos.length; i++) {
          pos[i] += (target[i] - pos[i]) * SETTLE_PULL;
        }
        model.posAttr.needsUpdate = true;

        if (Math.abs(pos[0] - target[0]) < SETTLE_EPS) {
          pos.set(target);
          model.posAttr.needsUpdate = true;
          model.points.material.opacity = 1;
          model.introDone = true;
        }
      }
    }

    // ===================== ANIMATE =====================
    const clock = new THREE.Clock();
    let tAccum = 0;

    function animate() {
      requestAnimationFrame(animate);
      if (!isVisible) return;

      const dt = Math.min(clock.getDelta(), 0.033);
      tAccum += dt;

      updateWaterIntro(modelA, tAccum);
      updateWaterIntro(modelB, tAccum);

      if (controls) {
        controls.update(dt);
      } else {
        scene.rotation.y += dt * 0.6;
      }

      renderer.render(scene, camera);
    }

    animate();
  }
})();
